var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    transform: "scale(-1,1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_arrow_left-rigth",
    transform: "translate(9 14) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_71",
    "data-name": "Rect\\xE1ngulo 71",
    width: 9,
    height: 14,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.22,9.8a.7.7,0,0,0,0,1.017.773.773,0,0,0,1.061,0l5-4.794A.7.7,0,0,0,6.28,5L1.28.211A.773.773,0,0,0,.22.211a.7.7,0,0,0,0,1.017l4.47,4.285Z",
    transform: "translate(7.5 12.5) rotate(180)",
    fill: "#1c1c1c",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/_arrow_left.adbf728f140c57d0d7b772cf7eb33fce.svg";
export { ForwardRef as ReactComponent };